module.exports = __webpack_public_path__ + "img/Truppführer_B_1.fd14876f.svg";